import React, { useEffect, useState } from "react";
import {
  CModal,
  CModalBody,
} from "@coreui/react";



import CategoryPicker from "./CategoryPicker";


import { useDispatch, } from "react-redux";
import crossButton from "../../../components/assets/image/crossButton.svg";
import "../../../components/common/styles/changePassword.css";
import "../../../components/common/styles/createAdmin.css";
import { hideAddPlanModal, showAddPlanModal } from "../redux/plansModalDispatcher";

import { addPlanRequest } from "../redux/planDispatcher";





const AddPlan = ({
  buttonLabel = "Add Plan",
  editMode = false,
  planData = {},
  categories = []
}) => {

  console.log("SGHSGHSGHSGH::::::", (planData.priorityPlacement || 2));



  const dispatch = useDispatch();

  const [isModalVisible, setIsModalVisible] = useState(false); // Local State
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [planName, setPlanName] = useState("");
  const [planDaysOfListing, setPlanDaysOfListing] = useState("");
  const [planPrice, setPlanPrice] = useState("");
  const [planBump, setPlanBump] = useState(1);
  const [planBumpWeek, setPlanBumpWeek] = useState(1);

  const [planPriorityPlacement, setPlanPriorityPlacement] = useState("");
  const [planNumberOfPhotos, setPlanNumberOfPhotos] = useState("");
  const [isRecommended, setIsRecommended] = useState(false);
  const [isDefaultPlan, setIsDefaultPlan] = useState(false);


  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {

    if (editMode && planData) {

      setPlanName(planData.planName || "");
      setPlanDaysOfListing(planData.daysOfListing || "");
      setPlanPrice(planData.price || "");
      setPlanBump(planData.bump ?? 1);
      setPlanBumpWeek(planData.bump_week ?? 1);
      setPlanPriorityPlacement(planData.priorityPlacement ?? 0);
      setPlanNumberOfPhotos(planData.numberOfPhotos || "");
      setIsRecommended(planData.recommended === 1 ? true : false);
      setIsDefaultPlan(planData.isDefaultPlan === 1 ? true : false);

      setSelectedOptions([]);

      const selectedIds = planData.category ? planData.category.split(',').map(Number) : [];

      const data = categories
        .filter(cat => selectedIds.includes(cat.id))
        .map(cat => ({
          value: cat.id,
          label: cat.name,
        }));

      setSelectedOptions(data);

    }
  }, [editMode, planData, categories]);



  const resetForm = () => {
    setPlanName("");
    setPlanDaysOfListing("");
    setPlanPrice("");
    setPlanBump(1);
    setPlanBumpWeek(1);
    setPlanPriorityPlacement("");
    setPlanNumberOfPhotos("");
    setIsRecommended(false);
    setSelectedOptions([]);
    setIsDefaultPlan(false);

  };









  // Handle Add Plan Submission
  const handleAddPlan = () => {


    console.log("Recommended:::::::::", selectedOptions);
    console.log("Recommended:::::::::", selectedOptions.map(item => item.value).join(','));

    if (planName.trim() === "") {
      alert("Plan name is required");
      return;
    }

    if (selectedOptions.length === 0) {
      alert("Please select category");
      return;
    }

    if (String(planDaysOfListing).trim() === "") {
      alert("Days is required");
      return;
    }

    if (String(planPrice).trim() === "") {
      alert("Price is required");
      return;
    }


    if (String(planBump).trim() === "") {
      alert("Bump is required");
      return;
    }


    if (String(planPriorityPlacement).trim() === "") {
      alert("Priority placement is required");
      return;
    }


    if (String(planNumberOfPhotos).trim() === "") {
      alert("Number of photos is required");
      return;
    }

    // if (planType.trim() === "") {
    //   alert("Plan type is required");
    //   return;
    // }

    var data = {
      "planName": planName,
      "daysOfListing": planDaysOfListing,
      "price": planPrice,
      "bump": planBump,
      "bump_week": planBumpWeek,
      "priorityPlacement": planPriorityPlacement,
      "numberOfPhotos": planNumberOfPhotos,
      "type": 1,
      "recommended": isRecommended ? 1 : 0,
      "isDefaultPlan": isDefaultPlan ? 1 : 0,

      'category': selectedOptions.map(item => item.value).join(',')
    };


    if (editMode) {
      data.id = planData.id;
    }

    dispatch(addPlanRequest(data));

    resetForm();
    setIsModalVisible(false);
    dispatch(hideAddPlanModal());
  };

  return (
    <div>
      {/* Button to Open Modal */}
      <button
        onClick={() => {
          if (!editMode) {
            resetForm(); // Reset the form if adding
          }
          setIsModalVisible(true)
          dispatch(showAddPlanModal())

        }}
        style={{
          backgroundColor: editMode === true ? "#1b87f4" : "rgb(0 0 0)",
          color: "white",
          border: "none",
          cursor: "pointer",
          borderRadius: "4px",
          fontSize: editMode === true ? "10px" : "14px",
          minWidth: "60px",
          // width: "100%",
          height: editMode === true ? "24px" : "30px",  // Increased height
          padding: editMode === true ? "2px 5px" : "4px 10px", // Added padding
          display: "flex",
          alignItems: "center",
          // alignSelf:"end",
          justifyContent: "center",
        }}
      >{buttonLabel}</button>

      <CModal
        alignment="center"
        visible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        className="attributemodal"

      >
        <CModalBody className="main-container createAdmin" >
          {/* Close Button */}
          <div className="cross-btn-div d-flex">
            <img
              onClick={() => setIsModalVisible(false)}
              src={crossButton}
              alt="close"
              className="cross-button"
            />
          </div>

          <form onSubmit={(e) => e.preventDefault()} className="login-form">
            <div className="mb-4">
              <h4
                className="h4 fw-bold"
                style={{ color: "#007bff", textAlign: "center" }}
              >
                <b>{editMode === true ? ("Edit Plan") : ("Add New Plan")}</b>
              </h4>
            </div>





            {/* Plan Name Input */}
            <div className="mb-3 input-login-box">
              <input
                value={planName}
                onChange={(e) => setPlanName(e.target.value)}
                name="planName"
                type="text"
                className="form-control login-input"
                placeholder="Enter plan name"
              />
            </div>



            {/* Categories this plan covers. Grouped by section, because a flat
                list of 227 names is unusable for picking a whole section. */}
            <div className="mb-3">
              <label style={{ fontSize: "13px", color: "#555", marginBottom: "4px", display: "block" }}>
                Categories this plan covers
              </label>
              <CategoryPicker
                categories={categories}
                value={selectedOptions.map((o) => o.value)}
                onChange={(ids) =>
                  setSelectedOptions(
                    ids
                      .map((id) => categories.find((c) => Number(c.id) === Number(id)))
                      .filter(Boolean)
                      .map((c) => ({ value: c.id, label: c.name }))
                  )
                }
              />
            </div>


            {/* Plan Price Input */}
            <div className="mb-3 input-login-box">
              <input
                type="number"
                step="0.01"
                min="0"
                value={planPrice}
                onChange={(e) => setPlanPrice(e.target.value)}
                name="planPrice"
                className="form-control login-input"
                placeholder="Enter plan Price"
                rows="3"
              />
            </div>




            {/* Number of days Input */}
            <div className="mb-3 input-login-box">
              <input
                type="number"
                pattern="[0-9]*"
                inputMode="numeric"
                value={planDaysOfListing}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    setPlanDaysOfListing(value); // only integers
                  }
                }}
                name="planDaysOfListing"
                className="form-control login-input"
                placeholder="Enter number of days"
                rows="3"
              />
            </div>










            {/* Plan Bump Dropdown */}
            <div className="mb-3 input-login-box">
              <select
                value={planBump}
                onChange={(e) => {
                  setPlanBump(e.target.value);
                  setPlanBumpWeek(e.target.value===1?1:e.target.value<=8?2:3)
                }}
                name="planBump"
                className="form-control login-input"
              >
                <option value="">Select plan bump</option>
                {[...Array(10)].map((_, index) => (
                  <option key={index + 1} value={index + 1}>
                    {index + 1}
                  </option>
                ))}
              </select>
            </div>


            {/* Plan Bump WeekInput */}
            <div className="mb-3 input-login-box">
              <input
                type="number"
                pattern="[0-9]*"
                inputMode="numeric"
                value={planBumpWeek}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    setPlanBumpWeek(value); // only integers
                  }
                }}
                name="planBumpWeek"
                className="form-control login-input"
                placeholder="Enter plan bump week"
                rows="3"
                readOnly
              />
            </div>

            {/* Plan Priority Input */}
            <div className="mb-3 input-login-box">
              <input
                type="number"
                pattern="[0-9]*"
                inputMode="numeric"
                value={planPriorityPlacement}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    setPlanPriorityPlacement(value); // only integers
                  }
                }}
                name="planPriorityPlacement"
                className="form-control login-input"
                placeholder="Enter plan priority placement"
                rows="3"
              />
            </div>







            {/* Plan Number Of Photos */}
            <div className="mb-3 input-login-box">
              <input
                type="number"
                pattern="[0-9]*"
                inputMode="numeric"
                value={planNumberOfPhotos}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    setPlanNumberOfPhotos(value); // only integers
                  }
                }}
                name="planNumberOfPhotos"
                className="form-control login-input"
                placeholder="Enter number of photos"
                rows="3"
              />
            </div>




            <div className="mb-3 form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="recommendedCheck"
                checked={isRecommended}
                onChange={() => setIsRecommended(!isRecommended)}
              />
              <label className="form-check-label" htmlFor="recommendedCheck">
                Is Recommended ?
              </label>
            </div>



            <div className="mb-3 form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="isDefaultPlan"
                checked={isDefaultPlan}
                onChange={() => setIsDefaultPlan(!isDefaultPlan)}
              />
              <label className="form-check-label" htmlFor="recommendedCheck">
                Is Defalut Plan ?
              </label>
            </div>






            {/* Submit Button */}
            <button
              className="w-100 btn btn-md btn-warning fw-bold text-light button-color"
              type="button"
              onClick={handleAddPlan}
            >
              {editMode ? "Update" : "Submit"}
            </button>
          </form>
        </CModalBody>
      </CModal>
    </div>
  );
};

export default AddPlan;
